import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface AgeOption {
  value: number
  label: string
}

/**
 * Returns localized age options for child age selection (0–17 years).
 * This hook should be used instead of the deprecated AGE_OPTIONS constant in constants/search.ts.
 */
function useAgeOptions(): Array<AgeOption> {
  const intl = useIntl()

  return useMemo(() => (
    Array.from({ length: 18 }, (_, age) => ({
      value: age,
      label: intl.formatMessage(
        {
          id: 'NH7cdUoW05E9Ponx9o8c',
          defaultMessage: '{age, plural, =0 {0-1 year} one {# year} other {# years}}',
          description: 'Child age option label in occupancy picker (e.g. "0-1 year", "1 year", "5 years")',
        },
        { age },
      ),
    }))
  ), [intl])
}

export default useAgeOptions
